import {
    Context
} from 'shared/context/GlobalState';
import {
    useContext, useEffect
} from 'react';
import {
    useNavigate
} from 'react-router-dom';

const RedirectUser = () => {
    const navigate = useNavigate();

    const {
        organizations
    } = useContext(Context);

    useEffect(() => {
        const storedOrganization = localStorage.getItem('selectedOrganization');
        const isOrgMember = organizations?.find(item => item._id === storedOrganization);
        if (isOrgMember) {
            navigate(`/organizations/${storedOrganization}`);
        } else {
            navigate('/organizations');
        }
    }, [navigate]);

    return null; // or loading spinner if needed
};

export default RedirectUser;
